import { Badge, Tab, Tabs } from '@mui/material'
import { styled } from '@mui/material/styles'
import React from 'react'

import Colors from '#/styles/Colors'
import Palette from '#/styles/Old/Palette'

// Componente StyledBadge
export const StyledBadge = props => (
  <Badge
    {...props}
    slotProps={{
      root: {
        style: {
          marginRight: 15,
        },
      },
      badge: {
        style: {
          backgroundColor: Colors.primary,
          color: 'white',
          lineHeight: '16px',
        },
      },
    }}
  />
)

// Componente StyledTab
export const StyledTab = styled(props => (
  <StyledBadge badgeContent={props.count}>
    <Tab disableRipple {...props} />
  </StyledBadge>
))({
  'color': 'black',
  'minWidth': 'unset',
  'minHeight': 'unset',
  'backgroundColor': Palette.grey.lighten[3],
  'borderRadius': 50,
  'opacity': 1,
  'padding': '5px 15px',
  '&.Mui-selected': {
    backgroundColor: Palette.primary.lighten[2],
    color: 'black !important',
  },
  '& .MuiTab-wrapper': {
    textTransform: 'capitalize',
    fontWeight: 'normal',
  },
})

// Componente StyledTabs
export const StyledTabs = styled(Tabs)({
  'minHeight': 'unset',
  'overflow': 'unset !important',
  'paddingTop': 10,
  'paddingBottom': 20,
  'backgroundColor': 'unset',
  '& .MuiTabs-scroller': {
    overflow: 'unset !important',
  },
  '& .MuiTabs-indicator': {
    display: 'none',
  },
})
